import {FullscreenOverlayContainer, OverlayContainer} from '@angular/cdk/overlay';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {ErrorHandler, NgModule, Optional, SkipSelf} from '@angular/core';
import {MAT_RIPPLE_GLOBAL_OPTIONS} from '@angular/material/core';
import {Title} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {
    MX_APPLICATION_PROPERTY_SERVICE_TOKEN,
    MX_ASSIGNMENT_COMPONENTS_SERVICE_TOKEN,
    MX_AUTHENTICATION_SERVICE_TOKEN,
    MX_ENVIRONMENT_TOKEN,
    MX_INFORMATION_SERVICE_TOKEN,
    MX_NAVIGATION_MENU_ELEMENTS_TOKEN,
    MX_PERMISSION_TOKEN,
    MX_REFERENCE_SERVICE_TOKEN,
    MX_REPORT_GENERATOR_TOKEN,
    MX_TIMEZONE_TOKEN,
    MX_TITLE_SERVICE_TOKEN,
    MX_TRANSLATE_SERVICE_TOKEN,
    MX_VALIDATION_MANAGER_SERVICE_TOKEN,
    MxDialogsModule,
    MxNavigationMenuModule,
    MxPreloaderModule
} from 'mx-core';
import {AppRoutingModule} from '../app-routing.module';
import {AppComponent} from '../app.component';
import {PrlErrorsHandler} from '../error-handler';
import {AssignmentComponentsService} from '../shared/services/assignment-components.service';
import {NavigationMenuElementsService} from '../shared/services/navigation-menu-elements.service';
import {PrlApplicationPropertiesDataService} from '../shared/services/prl-application-properties.service';
import {PrlAuthenticationService} from '../shared/services/prl-authentication.service';
import {PrlBasicAuthHttpInterceptorService} from '../shared/services/prl-basic-auth-http-interceptor.service';
import {PrlEnvironmentService} from '../shared/services/prl-environment.service';
import {PrlInformationService} from '../shared/services/prl-information.service';
import {PrlPermissionService} from '../shared/services/prl-permission.service';
import {PrlTimezoneService} from '../shared/services/prl-timezone.service';
import {PrlTitleAndBreadcrumbsService} from '../shared/services/prl-title-and-breadcrumbs.service';
import {SharedModule} from '../shared/shared.module';
import {ViewModule} from '../view/view.module';
import {PrlValidationManagerService} from '../shared/services/prl-validation-manager.service';
import {PrlToolbarModule} from '../view/prl-toolbar/prl-toolbar.module';
import {PrlLanguageModule} from '../view/prl-language/prl-language.module';
import {PrlTranslateService} from '../shared/services/prl-translate.service';
import {PrlReferencedEntityService} from "../shared/services/prl-referenced-entity.service";
import {MX_FORGOT_PASSWORD_SERVICE_TOKEN} from "../../../../mx-core/src/lib/shared/services/mx-forgot-password.service";
import {
    PrlForgotPasswordService
} from "../view/prl-authentication/services/prl-forgot-password/prl-forgot-password.service";
import {PrlGeneratorService} from "../shared/services/prl-generator.service";

@NgModule({
    imports: [
        SharedModule,
        HttpClientModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        ViewModule,
        MxNavigationMenuModule,
        MxPreloaderModule,
        MxDialogsModule,
        PrlToolbarModule,
        PrlLanguageModule
    ],
    declarations: [
        AppComponent
    ],
    providers: [
        Title,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: PrlBasicAuthHttpInterceptorService,
            multi: true
        },
        {
            provide: OverlayContainer,
            useClass: FullscreenOverlayContainer
        },
        {
            provide: ErrorHandler,
            useClass: PrlErrorsHandler
        },
        {provide: MX_APPLICATION_PROPERTY_SERVICE_TOKEN, useExisting: PrlApplicationPropertiesDataService},
        {provide: MX_ASSIGNMENT_COMPONENTS_SERVICE_TOKEN, useExisting: AssignmentComponentsService},
        {provide: MX_AUTHENTICATION_SERVICE_TOKEN, useExisting: PrlAuthenticationService},
        {provide: MX_ENVIRONMENT_TOKEN, useExisting: PrlEnvironmentService},
        {provide: MX_REPORT_GENERATOR_TOKEN, useExisting: PrlGeneratorService},
        {provide: MX_INFORMATION_SERVICE_TOKEN, useExisting: PrlInformationService},
        {provide: MX_NAVIGATION_MENU_ELEMENTS_TOKEN, useExisting: NavigationMenuElementsService},
        {provide: MX_PERMISSION_TOKEN, useExisting: PrlPermissionService},
        {provide: MX_REFERENCE_SERVICE_TOKEN, useExisting: PrlReferencedEntityService},
        {provide: MX_TIMEZONE_TOKEN, useExisting: PrlTimezoneService},
        {provide: MX_TITLE_SERVICE_TOKEN, useExisting: PrlTitleAndBreadcrumbsService},
        {provide: MX_TRANSLATE_SERVICE_TOKEN, useExisting: PrlTranslateService},
        {provide: MX_FORGOT_PASSWORD_SERVICE_TOKEN, useExisting: PrlForgotPasswordService},
        {provide: MX_VALIDATION_MANAGER_SERVICE_TOKEN, useExisting: PrlValidationManagerService},
        {
            provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: {
                disabled: true,
                animation: {
                    enterDuration: 300,
                    exitDuration: 0
                }
            }
        }
    ]
})
export class CoreModule {
    // Prevents CoreModule from being imported anywhere except AppModule
    constructor(@Optional() @SkipSelf() core: CoreModule) {
        if (core) {
            throw new Error('CoreModule should be imported in AppModule only');
        }
    }
}
